<template>
    <div>
        <div id="PengajuanManagement">
            <div class="overflow-auto">
                <h2>Konfirmasi Pengembalian Bilyet</h2>
                <div class="row no-gutters mb-4">
                    <div class="col-md-9">
                        <label>Filter Berdasarkan Tanggal :</label>
                        <div class="form-inline">
                            <input name="start_date" type="text" onfocus="(this.type='date')" placeholder="Mulai Dari"
                                class="form-control mr-2">
                            <input name="end_date" type="text" onfocus="(this.type='date')" placeholder="Sampai Dengan"
                                class="form-control mr-2">
                            <b-button class="btn btn-custom btn-sm" @click="applyDateFilter">Filter</b-button>
                        </div>
                    </div>
                </div>
                <div class="overflow-auto">
                    <b-table id="pengajuan-table" responsive="true" :items="pengajuanItems" :fields="pengajuanFields"
                        :current-page="currentPagePengajuan" :per-page="perPagePengajuan">
                        <template v-slot:cell(id_transaksi)="data">
                            <div>{{ data.item.id }}</div>
                        </template>
                        <template v-slot:cell(product)="data">
                            <div>{{ data.item.product.nama_produk }}</div>
                        </template>
                        <template v-slot:cell(funder)="data">
                            <div>{{ data.item.funder.name }}</div>
                        </template>
                        <template v-slot:cell(setoran_awal)="data">
                            <div>Rp.{{ new Intl.NumberFormat().format(data.item.setoran_awal) }}</div>
                        </template>
                        <template v-slot:cell(status_pengajuan)="data">
                            <div>{{ data.item.status_pengajuan.name }}</div>
                        </template>
                        <template v-slot:cell(status_pembayaran)="data">
                            <div>
                                {{ data.item.latest_payment_confirmation ? convertStatusPembayaran(data.item.latest_payment_confirmation.status) : 'Menunggu Pembayaran' }}
                            </div>
                        </template>
                        <template v-slot:cell(status_document)="data">
                            <div>
                                {{ data.item.status_pengajuan_id == 6 ? (data.item.document ? convertStatusDocument(data.item.document.status) : '-') : '-'}}
                            </div>
                        </template>
                        <template v-slot:cell(aksi)="data">
                            <b-button @click="showDetail(data.item)" type="button" variant="primary"
                                class="btn btn-custom theme-color">
                                Detail
                            </b-button>
                            <b-button v-if="data.item.document.status == 'funder_uploaded'" @click="changeStatus(data.item, 'approve')" type="button" variant="success"
                                class="btn btn-custom theme-color success">
                                Setujui
                            </b-button>
                            <b-button v-if="data.item.document.status == 'funder_uploaded'" @click="changeStatus(data.item, 'reject')" type="button" variant="danger"
                                class="btn btn-custom theme-color cancel">
                                Tolak
                            </b-button>
                        </template>
                    </b-table>
                </div>

                <b-modal size="lg" v-model="showDetailModal" hide-footer hide-header>
                    <div class="text-center">
                        <div class="d-block text-center">
                            <h3>{{ modalTitle }}</h3>
                        </div>
                        <p style="margin-bottom: 0px;"><strong>Nomor Resi</strong></p>
                        <h4>{{ nomor_resi || 'Tidak tersedia' }}</h4>
                        <b-img thumbnail fluid width="500px" height="500px" :src="bukti_pengembalian" alt="Bukti Pengembalian"></b-img>
                    </div>
                </b-modal>

                <b-modal size="lg" v-model="confirmStatusModal" hide-footer hide-header>
                    <div class="text-center">
                        <div class="d-block text-center">
                            <h3>{{ modalTitle }}</h3>
                        </div>
                        <p style="margin-bottom: 0px;"><strong>Nomor Resi</strong></p>
                        <h4>{{ nomor_resi || 'Tidak tersedia' }}</h4>
                        <b-img thumbnail fluid width="500px" height="500px" :src="bukti_pengembalian" alt="Bukti Pengembalian"></b-img>    
                        <div v-if="!changingStatus" class="row">
                            <div class="col">
                                <b-button class="mt-3 btn-custom success" block @click="confirmChangeStatus">Ya</b-button>
                            </div>
                            <div class="col">
                                <b-button class="mt-3 btn-custom cancel" block @click="confirmStatusModal = false">Tutup</b-button>
                            </div>
                        </div>
                        <div v-else class="row">
                            <div class="col text-center">
                                <b-spinner variant="primary"></b-spinner>
                            </div>
                        </div>
                    </div>
                </b-modal>

                <h2 v-if="loaded == false" class="text-center"><b-spinner variant="warning"></b-spinner></h2>
                <b-pagination align="center" :total-rows="rowsPengajuan" :per-page="perPagePengajuan"
                    aria-controls="pengajuan-table" v-model="currentPagePengajuan"></b-pagination>
            </div>
        </div>

        <b-modal size="sm" v-model="successModal" hide-footer hide-header>
            <div class="d-block text-center">
                <b-icon icon="check-circle" animation="throb" variant="success"
                    style="width: 120px; height: 120px;"></b-icon>
                <h3>Status berhasil diubah</h3>
            </div>
            <div class="row">
                <div class="col">
                    <b-button class="mt-3 btn-custom cancel" block @click="successModal = false">Tutup</b-button>
                </div>
            </div>
        </b-modal>

        <b-modal size="sm" v-model="errorModal" hide-footer hide-header>
            <div class="d-block text-center">
                <b-icon icon="exclamation-circle" animation="throb" variant="danger"
                        style="width: 120px; height: 120px;"></b-icon>
                <h3>{{ errorMessage }}</h3>
            </div>
            <div class="row">
                <div class="col">
                    <b-button class="mt-3" block @click="errorModal = false">Tutup</b-button>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import Pengajuan from '../../api/pengajuan.js';

const pengajuanFields = [
    { key: 'id_transaksi', label: 'ID Transaksi', sortable: false },
    { key: 'product', label: 'Nama Produk', sortable: true },
    { key: 'funder', label: 'Nama Funder', sortable: true },
    { key: 'setoran_awal', label: 'Setoran Awal', sortable: true },
    { key: 'status_pengajuan', label: 'Status Pengajuan', sortable: true },
    { key: 'status_pembayaran', label: 'Status Pembayaran', sortable: true },
    { key: 'status_document', label: 'Status Bilyet', sortable: true },
    { key: 'aksi', label: 'Aksi' }
];

export default {
    name: "KonfirmasiPengembalianBilyet",
    data() {
        return {
            pengajuanItems: [],
            pengajuanFields: pengajuanFields,
            perPagePengajuan: 5,
            currentPagePengajuan: 1,
            showDetailModal: false,
            confirmStatusModal: false,
            successModal: false,
            errorModal: false,        // Add this
            errorMessage: '',         // Add this
            modalTitle: '',
            changingStatus: false,
            loaded: false,
            bukti_pengembalian: null,
            nomor_resi: null,
            pengajuan_id: null,
        };
    },
    computed: {
        rowsPengajuan() {
            return this.pengajuanItems.length;
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            Pengajuan.pengajuanPengembalianMitra()
                .then(res => {
                    this.pengajuanItems = res.data.data.sort((a, b) => {
                    const statusA = a.document.status ? a.document.status : '';
                    const statusB = b.document.status ? b.document.status : '';
                    if (statusA == 'funder_uploaded') return -1;
                    if (statusB != 'funder_uploaded') return 1;
                    return 0;
                });
                    this.loaded = true;
                })
                .catch(err => console.log(err));
        },
        showDetail(item) {
            this.pengajuan_id = item.id;
            this.bukti_pengembalian = item.document.return_tracking_upload;
            this.nomor_resi = item.document.return_tracking_number;
            this.modalTitle = `Resi Pengembalian Bilyet Funder`;
            this.showDetailModal = true;
        },
        changeStatus(item, action) {
            this.pengajuan_id = item.id;
            this.bukti_pengembalian = item.document.return_tracking_upload;
            this.nomor_resi = item.document.return_tracking_number;
            if (action == 'approve') {
                this.modalTitle = `Apa anda yakin sudah menerima bilyet ini ?`;
            } else {
                this.modalTitle = `Apa anda yakin tidak menerima bilyet ini ?`;
            }
            this.action = action;
            this.confirmStatusModal = true;
        },
        confirmChangeStatus() {
            this.changingStatus = true;
            const data = {
                id: this.pengajuan_id,
            };
            Pengajuan.changePengajuanStatus(data)
                .then(res => {
                    if (res.data.meta.code === 200) {
                        this.confirmStatusModal = false;
                        this.successModal = true;
                        this.loadData();
                    } else if (res.data.meta.code === 400) {  // Handle invalid status response
                        this.confirmStatusModal = false;
                        this.errorMessage = res.data.meta.messages; // Set error message
                        this.errorModal = true; // Show error modal
                    }
                    this.changingStatus = false;
                })
                .catch(err => {
                    console.log(err);
                    this.changingStatus = false;
                });
        },
        convertStatusPembayaran(status) {
            switch (status) {
                case 'pending':
                    return 'Menunggu Konfirmasi Mitra';
                case 'approved':
                    return 'Disetujui Mitra';
                case 'rejected':
                    return 'Ditolak Mitra';
                default:
                    return '';
            }
        },
        convertStatusDocument(status) {
            switch (status) {
                case 'mitra_uploaded':
                    return 'Dikirim Mitra';
                case 'funder_received':
                    return 'Diterima Nasabah';
                case 'funder_uploaded':
                    return 'Dikirim Nasabah';
                case 'mitra_received':
                    return 'Diterima Mitra';
                default:
                    return '';
            }
        }
    },

};
</script>
<style scoped>
.overflow-auto {
    overflow-x: auto;
    /* Mengaktifkan scroll horizontal */
    white-space: nowrap;
    /* Mencegah pembungkusan teks */
}

.b-table {
    min-width: 800px;
    /* Sesuaikan dengan lebar minimal yang Anda inginkan */
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/konfirmasi-pengembalian-bilyet.vue